












































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { TaskDetailParam } from '@/@types/LibraryComponent';

@Component
export default class DatePickerMenu extends Vue {
  @Prop({ default: null })
  private readonly taskId!: number | null;
  @Prop({ default: null })
  private date!: string | null;
  @Prop()
  private attribute!: string;
  @Prop({ default: false })
  private customFlag!: boolean;
  private pickerDate: string | null = '';
  private displayDate: string | null = '';
  private menu: boolean = false;

  @Prop()
  public isTaskDetailModal!: boolean;

  @Emit('emitTaskData')
  private emitTaskData(): TaskDetailParam {
    return {
      taskId: this.taskId,
      value: this.pickerDate
        ? dayjs(this.pickerDate).format('YYYY-MM-DD')
        : null,
      attributeKey: this.attribute,
      customFlag: this.customFlag,
    };
  }

  private created() {
    this.displayDate = this.date ? dayjs(this.date).format('YYYY/MM/DD') : null;
    this.pickerDate = this.date ? dayjs(this.date).format('YYYY-MM-DD') : null;
  }

  private dateFormat(timestamp: string): string {
    return dayjs(timestamp).format('YYYY/MM/DD');
  }

  private save(date: string) {
    this.$refs.menu.save(date);
    this.emitTaskData();
  }
}
